import { motion,AnimatePresence } from 'framer-motion';
import React, { useEffect, useState } from 'react';



const roles = [
    "Frontend Developer",
    "Software Developer",
    "FullStack Developer"
]

export default function Titlerole(){
const [index,setIndex]= useState(0);

    useEffect(()=>{
        const id = setInterval(()=>{
            setIndex((prev)=>(prev+1) % roles.length)
        },2000)
        return() =>clearInterval(id);
    }, []);

    return(
        <div className='min-h-[2.75rem] sm:min-h-[3.25rem] overflow-hidden flex items-center'>
            <AnimatePresence mode='wait'>
                    <motion.span
                    key={roles[index]}
                    initial={{ y: -20, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 20, opacity: 0 }}
                    transition={{ type: 'spring', stiffness: 320, damping: 22 }}
                    className="block font-bold section-heading text-2xl sm:text-4xl"
                    >
                    {roles[index]}
                    </motion.span>
    
            </AnimatePresence>

        </div>
    );
}